import { ROUTES, type Settings } from '@serb/shared';
import { api } from '../../api/client';

export const settingsApi = {
  get: () => api.get<Settings>(ROUTES.api.settings),
  save: (settings: Settings) => api.put<Settings>(ROUTES.api.settings, settings),
};
